// extracted by mini-css-extract-plugin
export default {"container":"AdminReservations_container__lFTUq","tab-body":"AdminReservations_tab-body__Su2Ev"};